/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_qi as qi,
} from "../../runtime/index.jsx";
export function EstadoError(e) {
  let t = (0, ReactCompiler.c)(9),
    { mensaje: n, onReintentar: r } = e;
  if (!n) return null;
  let i;
  t[0] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((i = (0, JSXRuntime.jsx)(qi, {
        className: `mt-0.5 h-5 w-5 shrink-0 text-(--error)`,
      })),
      (t[0] = i))
    : (i = t[0]);
  let a;
  t[1] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((a = (
        <p
          className={`text-sm font-medium text-(--text-h)`}
          children={`Algo salio mal`}
        />
      )),
      (t[1] = a))
    : (a = t[1]);
  let o;
  t[2] === n
    ? (o = t[3])
    : ((o = <p className={`mt-0.5 text-sm text-(--text)`} children={n} />),
      (t[2] = n),
      (t[3] = o));
  let s;
  t[4] === r
    ? (s = t[5])
    : ((s = r && (
        <button
          type={`button`}
          onClick={r}
          className={`mt-2 rounded-full border border-(--border) px-3 py-1 text-xs font-medium text-(--text-h) transition hover:bg-(--accent-bg)`}
          children={`Reintentar`}
        />
      )),
      (t[4] = r),
      (t[5] = s));
  let c;
  return (
    t[6] !== o || t[7] !== s
      ? ((c = (
          <div
            className={`animar-entrada flex items-start gap-3 rounded-2xl border border-(--error-border) bg-(--error-bg) p-4`}
            children={[
              i,
              <div className={`min-w-0 flex-1`} children={[a, o, s]} />,
            ]}
          />
        )),
        (t[6] = o),
        (t[7] = s),
        (t[8] = c))
      : (c = t[8]),
    c
  );
}
